<template>
<modal-layout modal-name="edit-kosiwon-modal" :width="getSize()">
    <h1 slot="header">정보 수정요청</h1>
    <div slot="contents" class="contents">
        <ul>
            <li>
                <label>휴대폰 번호 <span>(입력해주신 번호로 답변드립니다.)</span></label>
                <input type="text" placeholder="-빼고 숫자만 입력" v-model="uploadData.phone_no" />
            </li>
            <li>
                <label>제목<span></span></label>
                <input type="text" placeholder="제목을 입력해 주세요." v-model="uploadData.title" />
            </li>
            <li>
                <label>수정 내용</label>
                <textarea placeholder="수정 내용을 입력해 주세요. 사진 수정을 원하실 경우에는 '고시원 올리기'를 통해 새로 등록해 주시거나, 교체할 이미지를 kosirock.winni@gmail.com 메일로 보내주세요." v-model="uploadData.contents"></textarea>
            </li>
        </ul>
        <div class="policy-check-view flex">
            <div>
                <input type="checkbox" id="policyCheckBox" v-model="isCheckedPrivacyAgree" /><label for="policyCheckBox">(필수) 개인정보 이용 동의</label>
            </div>
            <div>
                <span @click="openPrivacy">[약관 보기]</span>
            </div>
        </div>
    </div>
    <div slot="footer" class="send-footer">
        <button @click="uploadFixInfo">작성 완료</button>
    </div>
</modal-layout>
</template>

<script>
import ModalLayout from "../Layout/ModalLayout"
import Utils from "../../utils/Utils"

export default {
    name: "EditKosiwonModal",
    components: {
        ModalLayout
    },
    props: {
        kosiwonId: {
            type: String || Number,
            default: ""
        }
    },
    data() {
        return {
            uploadData: {
                phone_no: "",
                title: "",
                contents: ""
            },
            isCheckedPrivacyAgree: false
        }
    },
    methods: {
        getSize() {
            return Utils.isSmallScreen() ? "90%" : 500
        },
        async uploadFixInfo() {
            const phoneNoRegExp = /^\d{3}-?\d{3,4}-?\d{4}$/

            if (!this.kosiwonId) {
                alert("올바르지 못한 경로입니다.");
                return;
            } else if (this.uploadData.phone_no.trim() === "") {
                alert("휴대폰 번호는 필수로 입력해 주시기 바랍니다.\n입력하신 번호로 수정 확인 문자를 발송해드립니다.");
                return;
            } else if (!phoneNoRegExp.test(this.uploadData.phone_no)) {
                alert("유효한 휴대폰 번호를 입력해 주시기 바랍니다.\n입력하신 번호로 수정 확인 문자를 발송해드립니다.");
                return;
            } else if (this.uploadData.title.trim() === "") {
                alert("제목을 입력해주세요.");
                return;
            } else if (this.uploadData.contents.trim() === "") {
                alert("수정 내용을 입력해주세요.");
                return;
            } else if (!this.isCheckedPrivacyAgree) {
                alert("개인정보 처리방침에 동의 해주셔야 서비스 이용이 가능합니다.")
                return;
            }

            try {
                const uploadResult = await this.axios.post(`/kosiwons/${this.kosiwonId}/fixInfoProposal`, {
                    ...this.uploadData,
                });
                const result = uploadResult.data.result;
                this.clearData();

                if (result) {
                    alert("정보 수정 요청을 해주셔서 감사합니다.\n빠른 시일 내로 수정 후, 입력하신 휴대폰 번호로 연락드리겠습니다. 감사합니다.");
                    this.$modal.hide("edit-kosiwon-modal");
                }
            } catch (error) {
                alert("등록 도중 오류가 발생하였습니다. 잠시 후 다시 시도해 주시기 바랍니다.");
            }
        },
        clearData() {
            this.uploadData.phone_no = "";
            this.uploadData.title = "";
            this.uploadData.contents = "";
            this.isCheckedPrivacyAgree = false;
        },
        openPrivacy() {
            const routeData = this.$router.resolve({
                name: "privacy"
            });
            window.open(routeData.href, "_blank");
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/palette";

.header {
    font-size: 1.6rem;
}

.contents {
    li {
        padding-bottom: 2.3rem;

        /*padding: 0 4rem;*/
        label {
            display: block;
            font-weight: bold;
            font-size: 1.4rem;
            padding: 1.25rem 0;

            span {
                font-size: 1.2rem;
            }
        }

        input {
            min-height: 4rem;
            border-bottom: 2px solid @black-two;
        }

        input,
        textarea {
            box-sizing: border-box;
            width: 100%;
            display: block;
        }

        textarea {
            border: 1px solid #d6d6d6;
            padding: 1rem;
            min-height: 27rem;
        }
    }

    .policy-check-view {
        justify-content: space-between;
        padding-top: 2rem;

        /*font-size: 2rem;*/
        div {
            &:first-child {
                input[type=checkbox] {
                    margin-right: 1rem;
                }
            }

            &:last-child {
                span {
                    color: @windows-blue-two;
                    font-weight: bold;
                }
            }
        }
    }
}

.send-footer {

    /*padding: 1.5rem 4rem 0;*/
    button {
        height: 50px;
        background-color: @windows-blue;
        width: 100%;
        color: white;
    }
}
</style>
